import { Icon } from "@src/straps/base";
import { ClickableDiv } from "@src/straps/utils/ClickableDiv";

const ExpandCollapseButton = ({
  onClick,
  isCollapsedModeEnabled,
  dataTestId,
  name,
  ...style
}: {
  readonly onClick: () => void;
  readonly isCollapsedModeEnabled: boolean;
  readonly dataTestId: string;
  readonly name: string;
} & Readonly<Pick<HTMLDivElement["style"], "top" | "right" | "zIndex">>) => (
  <ClickableDiv
    className="absolute flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-full bg-white outline-straps-hyperlink-hover drop-shadow-md hover:bg-straps-positive-bg"
    onClick={(e) => {
      e.preventDefault();
      e.currentTarget.blur();
      onClick();
    }}
    style={style}
    data-testid={dataTestId}
    aria-label={isCollapsedModeEnabled ? `Expand ${name}` : `Collapse ${name}`}
  >
    <Icon
      name={isCollapsedModeEnabled ? "move-right" : "move-left"}
      size="small"
      color="primary"
    />
  </ClickableDiv>
);

export default ExpandCollapseButton;
